import * as React from 'react';
import {
    ArrowDownRightIcon,
    ArrowUpRightIcon,
    CoinsIcon,
    Icon,
    View,
} from 'smoothie';

import { TransactionDcSign } from '../../../types/Transactions';

interface TransactionIconProps {
    dcSign: TransactionDcSign;
    isInterestPayout: boolean;
}

const LegacyTransactionIcon = ({
    dcSign,
    isInterestPayout,
}: TransactionIconProps) => {
    return (
        <View padding={16} borderRadius={12} backgroundColor="$gray100">
            <Icon
                icon={
                    isInterestPayout
                        ? CoinsIcon
                        : dcSign === TransactionDcSign.CREDIT
                          ? ArrowUpRightIcon
                          : ArrowDownRightIcon
                }
                size={16}
            />
        </View>
    );
};

export default LegacyTransactionIcon;
